var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_ContractConfiguration"),
        width: "960px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          attrs: {
            inline: true,
            "label-width": "70px",
            "label-position": "left"
          }
        },
        [
          _c(
            "div",
            { staticStyle: { height: "380px" } },
            [
              _c("el-form-item", {
                staticStyle: { display: "block" },
                attrs: { label: _vm.$t("CargoMsg.Cargo_ContractRule") }
              }),
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: {
                      width: "220px",
                      "margin-right": "20px",
                      height: "330px"
                    },
                    attrs: {
                      "column-defs": _vm.ruleColumnDefs,
                      "grid-options": _vm.ruleGridOptions,
                      "row-data": _vm.ruleRowData,
                      "show-side-bar": false
                    }
                  }),
                  _c(
                    "div",
                    { staticStyle: { width: "648px" } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { display: "block" },
                          attrs: { label: _vm.$t("SystemMaintenance.RuleName") }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "180px" },
                            attrs: { maxlength: "40" },
                            on: {
                              input: function(p) {
                                _vm.ruleGridOptions.api.refreshCells({
                                  force: true
                                })
                                _vm.currentRule.isEdit = true
                              }
                            },
                            model: {
                              value: _vm.currentRule.name,
                              callback: function($$v) {
                                _vm.$set(_vm.currentRule, "name", $$v)
                              },
                              expression: "currentRule.name"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { display: "block" },
                          attrs: {
                            label: _vm.$t(
                              "CargoMsg.Cargo_ApplicationConditions"
                            )
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "180px" },
                            attrs: {
                              "static-options": _vm.ruleModes,
                              clearable: "",
                              "tag-value": "code",
                              "default-value": _vm.currentRule.mode,
                              disabled: _vm.currentRule.existContract,
                              required: ""
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.currentRule.mode = p.value
                                _vm.currentRule.isEdit = true
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c("cargo-ag-grid", {
                        staticStyle: {
                          height: "260px",
                          "padding-left": "70px"
                        },
                        attrs: {
                          "column-defs": _vm.ruleItemColumnDefs,
                          "grid-options": _vm.ruleItemGridOptions,
                          "row-data": _vm.currentRule.contractRuleItems,
                          "show-side-bar": false
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("div", {
            staticStyle: {
              "border-bottom": "2px solid #E3E3E3",
              "margin-top": "10px",
              "margin-bottom": "10px"
            }
          }),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("div", [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "line-height": "25px",
                          "font-weight": "bold"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("CargoMsg.Cargo_ContractWarning") + "："
                          )
                        )
                      ]
                    )
                  ]),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "margin-left": "20px",
                            "margin-right": "5px"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_TimeLeftUntilExpiry"))
                          )
                        ]
                      ),
                      _c("el-input-number", {
                        staticStyle: { width: "70px" },
                        attrs: {
                          no: "warnDays",
                          min: 0,
                          precision: 0,
                          controls: false
                        },
                        model: {
                          value: _vm.contractConfig.warnDays,
                          callback: function($$v) {
                            _vm.$set(_vm.contractConfig, "warnDays", $$v)
                          },
                          expression: "contractConfig.warnDays"
                        }
                      }),
                      _c("span", { staticStyle: { "margin-left": "5px" } }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DayRemind")))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("el-form-item", { staticClass: "form-item-check" }, [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "margin-left": "20px",
                          "margin-right": "5px"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_NotifyUser") + "：")
                        )
                      ]
                    ),
                    _c("br"),
                    _c(
                      "div",
                      { staticStyle: { "padding-left": "20px" } },
                      [
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "margin-right": "10px" },
                            attrs: {
                              no: "warnAdmin",
                              title: _vm.$t(
                                "CargoMsg.Cargo_ContractAdministrator"
                              )
                            },
                            model: {
                              value: _vm.contractConfig.warnAdmin,
                              callback: function($$v) {
                                _vm.$set(_vm.contractConfig, "warnAdmin", $$v)
                              },
                              expression: "contractConfig.warnAdmin"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_ContractAdministrator")
                              )
                            )
                          ]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "margin-right": "10px" },
                            attrs: {
                              no: "warnSale",
                              title: _vm.$t("CargoMsg.Cargo_Sales")
                            },
                            model: {
                              value: _vm.contractConfig.warnSale,
                              callback: function($$v) {
                                _vm.$set(_vm.contractConfig, "warnSale", $$v)
                              },
                              expression: "contractConfig.warnSale"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Sales")))]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "margin-right": "10px" },
                            attrs: {
                              no: "warnCustomerService",
                              title: _vm.$t("CargoMsg.Cargo_CustomerService")
                            },
                            model: {
                              value: _vm.contractConfig.warnCustomerService,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.contractConfig,
                                  "warnCustomerService",
                                  $$v
                                )
                              },
                              expression: "contractConfig.warnCustomerService"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_CustomerService"))
                            )
                          ]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            attrs: {
                              no: "warnSupplierDirector",
                              title: _vm.$t("baseInfo.partner.supplierDirector")
                            },
                            model: {
                              value: _vm.contractConfig.warnSupplierDirector,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.contractConfig,
                                  "warnSupplierDirector",
                                  $$v
                                )
                              },
                              expression: "contractConfig.warnSupplierDirector"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("baseInfo.partner.supplierDirector")
                              )
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "margin-left": "20px",
                          "margin-right": "5px"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_NotifyMethod") + "：")
                        )
                      ]
                    ),
                    _c("br"),
                    _c(
                      "div",
                      { staticStyle: { "padding-left": "20px" } },
                      [
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "margin-right": "10px" },
                            attrs: {
                              disabled: true,
                              no: "bellReminder",
                              title: _vm.$t("CargoMsg.Cargo_Bell")
                            },
                            model: {
                              value: _vm.bellReminder,
                              callback: function($$v) {
                                _vm.bellReminder = $$v
                              },
                              expression: "bellReminder"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Bell")))]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "margin-right": "10px" },
                            attrs: {
                              no: "mailReminder",
                              title: _vm.$t("CargoMsg.Cargo_Email2")
                            },
                            model: {
                              value: _vm.contractConfig.mailReminder,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.contractConfig,
                                  "mailReminder",
                                  $$v
                                )
                              },
                              expression: "contractConfig.mailReminder"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Email2")))]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticStyle: {
                "line-height": "25px",
                "font-weight": "bold",
                color: "red"
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_NoteReminderMethod")))]
          ),
          _c("div", {
            staticStyle: {
              "border-bottom": "2px solid #E3E3E3",
              "margin-top": "10px",
              "margin-bottom": "10px"
            }
          }),
          _c(
            "span",
            { staticStyle: { "line-height": "25px", "font-weight": "bold" } },
            [
              _vm._v(
                _vm._s(_vm.$t("CargoMsg.Cargo_ProhibitBusinessConfiguration"))
              )
            ]
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { "margin-left": "20px" },
                          attrs: { no: "forbidCreate" },
                          model: {
                            value: _vm.contractConfig.forbidCreate,
                            callback: function($$v) {
                              _vm.$set(_vm.contractConfig, "forbidCreate", $$v)
                            },
                            expression: "contractConfig.forbidCreate"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BWNBCAED")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { "text-align": "center" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: {
                no: "confirm",
                type: "primary",
                disabled: _vm.saveBtnEnabled
              },
              on: { click: _vm.saveEventHander }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }